

export enum EnumTipoFundo {
  Imagem = 0,
  Cor = 1,
}
